import React from 'react'
import { V4_T } from './propertyDetailHelpers'
import { TRIAGE_FILTERS } from './propertyReviewQueue'

// Positive-phrased display rows over the triage predicates. `fix` routes the
// failing state: 'checklist' opens the edit panel's Checklist tab, 'takeoff'
// deep-links to SiteTakeoffV3, 'aspire' deep-links to the Aspire property.
// Exported: the Property Setup Board reuses these labels/keys for its columns.
export const CHECK_ROWS = [
  { key: 'linesUnverified', label: 'Property lines verified', fix: 'checklist' },
  { key: 'noGeofence', label: 'Geofence set', fix: 'checklist' },
  { key: 'takeoffIncomplete', label: 'Takeoff marked complete', fix: 'checklist' },
  { key: 'noHerbicideAreas', label: 'Herbicide areas marked', fix: 'takeoff' },
  { key: 'noLatLng', label: 'Lat/Lng present', fix: 'aspire' },
  { key: 'noJobsite', label: 'Takeoff site linked', fix: 'takeoff' }
]

const testByKey = Object.fromEntries(TRIAGE_FILTERS.map(f => [f.key, f.test]))

const fixStyle = { fontSize: 11, fontWeight: 700, color: V4_T.rust, background: 'none', border: 'none', cursor: 'pointer', padding: 0, textDecoration: 'none', letterSpacing: '0.04em' }

function FixAction ({ row, property, jobsiteId, onOpenChecklist }) {
  if (row.fix === 'checklist') {
    return <button type="button" style={fixStyle} onClick={onOpenChecklist}>FIX</button>
  }
  if (row.fix === 'aspire') {
    return (
      <a style={fixStyle} href={`https://cloud.youraspire.com/app/properties/overview/${property.propertyId}`} target="_blank" rel="noopener noreferrer">FIX</a>
    )
  }
  // 'takeoff' — degrade to plain text when there is no jobsite to link to.
  if (!jobsiteId) return <span style={{ ...fixStyle, cursor: 'default' }}>FIX</span>
  return (
    <a style={fixStyle} href={`/site-takeoff/${jobsiteId}`} target="_blank" rel="noopener noreferrer">FIX</a>
  )
}

function PropertyReviewStatusCard ({ property, jobsiteId, onOpenChecklist }) {
  if (!property) return null
  const rows = CHECK_ROWS.map(row => ({ ...row, failing: !!testByKey[row.key](property) }))
  const done = rows.filter(r => !r.failing).length
  return (
    <div style={{ background: 'rgba(251,248,241,0.96)', border: `1px solid ${V4_T.line}`, borderRadius: 12, padding: '14px 16px', minWidth: 260, boxShadow: '0 2px 10px rgba(28,36,25,0.08)' }}>
      <div style={{ fontSize: 11, fontWeight: 700, letterSpacing: '0.08em', color: V4_T.mute, marginBottom: 10, fontFamily: 'monospace' }}>
        {`SETUP STATUS · ${done}/6`}
      </div>
      {rows.map(row => (
        <div key={row.key} style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '5px 0' }}>
          <span aria-hidden="true" style={{ width: 18, height: 18, borderRadius: '50%', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', fontSize: 11, background: row.failing ? 'transparent' : V4_T.green, color: '#fff', border: row.failing ? `1.5px solid ${V4_T.line}` : 'none' }}>
            {row.failing ? '' : '✓'}
          </span>
          <span style={{ flex: 1, fontSize: 13, color: V4_T.ink2, fontWeight: 600 }}>{row.label}</span>
          {row.failing
            ? <FixAction row={row} property={property} jobsiteId={jobsiteId} onOpenChecklist={onOpenChecklist} />
            : <span style={{ fontSize: 11, fontWeight: 700, color: V4_T.green, letterSpacing: '0.04em' }}>DONE</span>}
        </div>
      ))}
    </div>
  )
}

export default PropertyReviewStatusCard
